import { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { pushRegistrationGAEvent } from '@comeon/analytics';

import BankID from '~/components/authentication/bankid/bankid';
import { BANKID_MODES } from '~/components/authentication/bankid/configs';
import { isSessionCriteriaFulfilled } from '~/components/authentication/bankid/utils';
import { authenticationSelector } from '~/components/authentication/ducks/selectors';
import ModalPopupLogin from '~/components/authentication/login/modal-popup/modal-popup';
import WizardSidebar from '~/components/authentication/playnow/steps/common/sidebar';
import useWizard from '~/components/authentication/wizard/hooks/use-wizard';
import useTranslations from '~/components/translation/use-translations';

const textKeys = ['BANKID_CONTINUE_SAME_DEVICE'];

const BankIDStep = props => {
	const { next } = useWizard();
	const sessionCriteria = useSelector(state => state.bankId.sessionCriteria, shallowEqual);
	const isAuthenticated = useSelector(authenticationSelector);
	const { translations } = useTranslations(textKeys);

	useEffect(() => {
		if (sessionCriteria) {
			// transform criteria back to response structure.
			const criteria = {
				...sessionCriteria,
				isEmailSet: !sessionCriteria.shouldShowEmail,
				isMobileNumberSet: !sessionCriteria.shouldShowPhone
			};

			// in case session criteria is fulfilled wait till session is set
			if (isSessionCriteriaFulfilled(criteria) && !isAuthenticated) {
				return;
			}

			next();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [sessionCriteria, isAuthenticated]);

	const bankIDComplete = isAuthenticated || !!sessionCriteria;

	if (bankIDComplete) {
		return <div className="spinner" />;
	}

	return (
		<>
			<WizardSidebar.Header />
			<WizardSidebar.Content>
				<ModalPopupLogin />
				<BankID
					gaEventCb={pushRegistrationGAEvent}
					mode={BANKID_MODES.PLAY_NOW}
					title={translations.BANKID_CONTINUE_SAME_DEVICE}
					{...props}
				/>
			</WizardSidebar.Content>
		</>
	);
};

export default BankIDStep;
